import React from 'react';
import { DescriptionColumn } from './description-column';
import { ProviderColumn } from './provider-column';
import { Row } from './row';

export const ColumnHeadingRow = ({ providers }) => (
  <Row paddingBottom={'10px'}>
    <DescriptionColumn></DescriptionColumn>
    {providers.map((provider) => (
      <ProviderColumn key={`columnHeading_${provider.id}`} fontSize={'14px'}>
        {provider.label}
      </ProviderColumn>
    ))}
  </Row>
);
